/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

// Browser error tracking. No-op when the DSN is empty (dev / not configured yet).
if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.type,
    // Forward LoggerService.info/warn/debug to Sentry's structured Logs stream.
    enableLogs: true,
    // Keep performance tracing light; bump if/when we need it.
    tracesSampleRate: 0.1,
    // GDPR: never attach IP/cookies/user PII automatically.
    sendDefaultPii: false,
    beforeSend(event) {
      // Defensive scrub in case a transport ever carries request context.
      if (event.request) {
        delete event.request.cookies;
        delete event.request.headers;
      }
      delete event.user;
      return event;
    },
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
